export enum RoundingPrecisionTypeEnum {
  PENNIES = 'PENNIES',
  WHOLE = 'WHOLE',
}

export const priceRoundingPrecisionTypeOptions=[
   { id: RoundingPrecisionTypeEnum.PENNIES, value: 'Haléře' },
   { id: RoundingPrecisionTypeEnum.WHOLE, value: 'Koruny' },
];
